"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = require("@lt/localization");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HotelCardFact = _interopRequireDefault(require("./HotelCardFact"));

var _Plane = _interopRequireDefault(require("../../icons-react/userflow/Plane"));

var _userflow = require("../../utils/userflow");

// import IconPlane from '../../icons/userflow/plane.svg';
var TOOLTIP = _localization.i18n.t('hotelcard.facts.airport');

var HotelBeachDistance = function HotelBeachDistance(_ref) {
  var value = _ref.value,
      className = _ref.className;
  return value ? /*#__PURE__*/_react["default"].createElement(_HotelCardFact["default"], {
    className: className,
    tooltip: TOOLTIP,
    label: (0, _userflow.formatDistance)(value),
    icon: /*#__PURE__*/_react["default"].createElement(StyledIconPlane, null)
  }) : null;
};

var StyledIconPlane = (0, _styledComponents["default"])(_Plane["default"]).withConfig({
  displayName: "HotelAirportDistance__StyledIconPlane",
  componentId: "sc-mq351p-0"
})(["fill:none;"]);
HotelBeachDistance.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number
};
HotelBeachDistance.defaultProps = {
  className: '',
  value: null
};

var _default = /*#__PURE__*/_react["default"].memo(HotelBeachDistance);

exports["default"] = _default;